module.exports = __webpack_public_path__ + "img/baogaobg1.e15d8228.png";